import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline';

import { cn } from '@/lib/utils';

interface EmptyStateProps {
  readonly message?: string;
  readonly entityType?: string;
  readonly className?: string;
}

export const EmptyState = ({
  message,
  entityType,
  className,
}: EmptyStateProps) => {
  const defaultMessage = entityType
    ? `No ${entityType} data`
    : 'No data available';

  return (
    <div className={cn('flex items-center gap-2 p-2 text-gray-500', className)}>
      <QuestionMarkCircleIcon className="h-3.5 w-3.5 shrink-0" />
      <p className="text-[11px] font-medium">{message || defaultMessage}</p>
    </div>
  );
};
